module.exports = __webpack_public_path__ + "static/img/robot.beaaab68.svg";